import type { EmployeeFormatted } from '@/api/employees/employees.types';
import { Table } from '@/components/table/Table';
import { useTableState } from '@/components/table/useTableState';
import type { EmployeeCommunicationFormatted } from '@/features/beneficiaries/beneficiaries.types';
import { employeeCommunicationsColumns } from '../columns/communications-columns';

interface EmployeeCommunicationsProps {
  employee: EmployeeFormatted;
  search: string;
  dateFilter?: Date | null;
}

export function EmployeeCommunications(props: EmployeeCommunicationsProps) {
  const { employee, search, dateFilter } = props;
  const communications: EmployeeCommunicationFormatted[] = employee.employeeCommunications ?? [];
  const tableState = useTableState('employee-communications', {
    columns: employeeCommunicationsColumns,
  });

  return (
    <Table
      entity={{ singular: 'échange' }}
      data={communications}
      columns={employeeCommunicationsColumns}
      search={search}
      // The parent's DatePicker owns the date column and stays ephemeral: it is injected over
      // the controller's filters so it is neither persisted nor cleared by the reset strip.
      tableState={{
        ...tableState,
        columnFilters: [
          ...tableState.columnFilters.filter((filter) => filter.id !== 'dateTime'),
          ...(dateFilter ? [{ id: 'dateTime', value: dateFilter }] : []),
        ],
      }}
    />
  );
}
